import gql from 'graphql-tag';

const programCurriculumProductsQuery = gql`
  query ProgramCurriculumProductsQuery($programId: String!, $limit: Int!) {
    ProgramCurriculumProductsV1Resource {
      enrolled(programId: $programId, limit: $limit) {
        elements {
          id
          productState {
            ... on ProgramCurriculumProductsV1_programCourseWithStateMember {
              productState: programCourseWithState {
                courseId
              }
            }
          }
        }
      }
    }
  }
`;
export default programCurriculumProductsQuery;
